import { React, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Tooltip, Row, Col, Form, Input, Button, PageHeader, Table, Switch} from "antd";
import { GlobalSet, Styled } from "../../pageStyled";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import moment from "moment";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import EmptyState from "../../../Components/EmptyState/emptyState";
import { HaberForm } from "../../styledElements";
import { getPackagingDetails } from "../../../Services/packagingService";
import AddReelPackaging from "../../../Pages/Configurations/PackagingModule/addReelPackagingDrawer";
import { updatePackagingDetails } from "../../../Services/packagingService";

const PackagingConfig = (props) => {
  const [switchTooltip, setSwitchTooltip] = useState(true);
  const [userDetails, setUserDetails] = useState(JSON.parse(localStorage.getItem("user-details")));
  const [settings, setSettings] = useState();
  const [rendering , setRendering] = useState(true);
  const toggleRef = useRef();
  const [reelData, setReelData] = useState([]);
  const [sheetData, setSheetData] = useState([]);  
  const [newReelSideDrawer, setNewReelSideDrawer] = useState(false);
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [packagingType, setPackagingType] = useState("");
  const [actionType, setActionType] = useState("");
  const [dataToPass, setDataToPass] = useState("");

  useEffect(() => {
    if(rendering){
      fetchPackaginigDetails();
      setRendering(false);
    }
  }, [rendering]);

  const fetchPackaginigDetails = async () => {
    const resp = await getPackagingDetails();
    if (!resp?.data?.error) {
      let reelDataArr = [];
      let sheetDataArr = [];
      resp?.data?.data?.map(item => {
        if(item.type === "reel"){
          reelDataArr.push(item);
        } else{
          sheetDataArr.push(item);
        }       
      });
      setReelData(reelDataArr);
      setSheetData(sheetDataArr);
    }
  }

  const handleSwitchForPackaging = async (checked, item) => {
    let reqBody = {
        name: item.name,
        description: item.description,
        quantity_type: item.quantity_type,
        ...item.quantity_type === "weight" ? {weight: item.weight} : {quantity: item.quantity},
        type: item.type,
        remarks: item.remarks,
        status: checked ? "active" : "disabled",
        ...item.quantity_type === "weight" && ({units : {weight: item.units.weight}}),
      };
    try{
      let resp = await updatePackagingDetails(item?.id , reqBody);
      if(!resp?.data.error){
        setActionToaster({
          error: resp?.data.error,
          msg: resp?.data.msg
        });
        showToaster();
      }
      setRendering(true);
    } catch (err) {
      // console.log(err.response.data.msg)
      setActionToaster({
        error: err?.data?.error,
        msg: err?.response?.data?.msg
      });
      showToaster();
    }
  };
  
  const showEditDeletePackagingForReel = (item, action, type) => {
    setPackagingType(type);
    setActionType(action);
    setDataToPass(item);
    setNewReelSideDrawer(true);
  };

  const showEditDeletePackagingForSheet = (item, action, type) => {
    setPackagingType(type);
    setActionType(action);
    setDataToPass(item);
    setNewReelSideDrawer(true);
  };

  const addNewPackagingDrawer = (type, action) => {
    setPackagingType(type);
    setActionType(action);
    setNewReelSideDrawer(true);
  };

  const onClosePackagingDrawer = (name, alias) => {
    setNewReelSideDrawer(false);
    setDataToPass("");
    setRendering(true);
  };

  const showToaster = () => {
    setVisibleToaster(true);
    setTimeout(() => setVisibleToaster(false), 2000);
  };
  
    return (
        <RightLayoutContainer className="globalset">
            <PageTitleComp>
            <PageHeader
            ghost={false}
            title="Packaging Configuration">
          </PageHeader>
            </PageTitleComp>
            <DetailFields>
                <HaberForm>
                <div className="groupDetailWrap">
                <Form name="basic" autoComplete="off" className="haberLogin">
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Reel packaging</h2>
                        <p>Reels can be packaged to the enabled packaging type</p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                    {reelData?.map((item) => {
                      return (
                        <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label style={{fontSize:"14px"}}>
                                  {item.name}
                                </label>
                                <p> {item.description}</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <GlobalSet>
                                  <Styled>
                                  <Tooltip
                                  className="edit-tooltip"
                                  placement="bottomRight"
                                  title={
                                    userDetails.roles.packaging_config.edit
                                      ? "Edit this packaging type."
                                      : "View details of this packaging type."
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Button
                                    key="3"
                                    className="textTypeBtn edit-btn"
                                    onClick={() =>
                                      showEditDeletePackagingForReel(item, (userDetails.roles.packaging_config.edit ? "edit" : "view"), "reel")
                                    }
                                  >
                                    <Iconmoon
                                      icon={userDetails.roles.packaging_config.edit ? "edit" : "file-view"}
                                      size={16}
                                      color="#605E5C"
                                    />
                                  </Button>
                                  </Tooltip>
                                  <Tooltip
                                  placement="bottomRight"
                                  title={
                                    userDetails.roles.packaging_config.edit
                                      ? item.status === "active"
                                        ? `Disable using of ${item.name} during packaging.`
                                        : `Enable using of ${item.name} during packaging.`
                                      : `${item.name} can be used during packaging.`
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Switch
                                    ref={toggleRef}
                                    checked={item.status === "active" ? true : false}
                                    onChange={(e) => handleSwitchForPackaging(e, item)}
                                    className="switch-new"
                                    disabled={!userDetails.roles.packaging_config.edit}
                                  />
                                </Tooltip>
                                  </Styled>
                                </GlobalSet>
                              </div>
                            </Col>
                        </Row>
                      )
                    })}
                    {userDetails.roles.packaging_config.edit && (
                      <Row className="centerAlign">
                        <Col span={12}>
                        <GlobalSet>
                          <div className="boxFieldTitle">
                            <Button
                              key="3"
                              className="textTypeBtn textBtnIcon"
                              style={{marginLeft:"-8px"}}
                              onClick={() => addNewPackagingDrawer("reel","add")}
                            >
                              <Iconmoon
                                icon="addcircle"
                                size={16}
                                color="#EA655B"
                              />
                              Add a new Reel Packaging
                            </Button>
                          </div>
                        </GlobalSet>
                        </Col>
                      </Row>
                    )}
                    </Col>
                  </Row>
                  <Row gutter={[16, 16]} className="groupForm">
                    <Col span={8}>
                      <GroupTitle>
                        <h2>Sheet packaging</h2>
                        <p>Sheets can be packaged to the enabled packaging type</p>
                      </GroupTitle>
                    </Col>
                    <Col span={16}>
                    {sheetData?.map((item) => {
                      return (
                        <Row className="centerAlign">
                            <Col span={12}>
                              <div className="boxFieldTitle">
                                <label style={{fontSize:"14px"}}>
                                  {item.name}
                                </label>
                                <p> {item.description}</p>
                              </div>
                            </Col>
                            <Col span={12}>
                              <div className="boxFormType">
                                <GlobalSet>
                                  <Styled>
                                  <Tooltip
                                  className="edit-tooltip"
                                  placement="bottomRight"
                                  title={
                                    userDetails.roles.packaging_config.edit
                                      ? "Edit this packaging type."
                                      : "View details of this packaging type."
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Button
                                    key="3"
                                    className="textTypeBtn edit-btn"
                                    onClick={() =>
                                      showEditDeletePackagingForSheet(item,(userDetails.roles.packaging_config.edit ? "edit" : "view"),"sheet")
                                    }
                                  >
                                    <Iconmoon
                                      icon={userDetails.roles.packaging_config.edit ? "edit" : "file-view"}
                                      size={16}
                                      color="#605E5C"
                                    />
                                  </Button>
                                  </Tooltip>
                                  <Tooltip
                                  placement="bottomRight"
                                  title={
                                    userDetails.roles.packaging_config.edit
                                      ? item.status === "active"
                                        ? `Disable using of ${item.name} during packaging.`
                                        : `Enable using of ${item.name} during packaging.`
                                      : `${item.name} can be used during packaging.`
                                  }
                                  getPopupContainer={(triggerNode) =>
                                    triggerNode
                                  }
                                >
                                  <Switch
                                    ref={toggleRef}
                                    checked={item.status === "active" ? true : false}
                                    onChange={(e) => handleSwitchForPackaging(e, item)}
                                    className="switch-new"
                                    disabled={!userDetails.roles.packaging_config.edit}
                                  />
                                </Tooltip>
                                  </Styled>
                                </GlobalSet>
                              </div>
                            </Col>
                        </Row>
                      )
                    })}
                    {userDetails.roles.packaging_config.edit && (
                      <Row className="centerAlign">
                        <Col span={12}>
                        <GlobalSet>
                          <div className="boxFieldTitle">
                            <Button
                              key="3"
                              className="textTypeBtn textBtnIcon"
                              style={{marginLeft:"-8px"}}
                              onClick={() => addNewPackagingDrawer("sheet","add")}                            >
                              <Iconmoon
                                icon="addcircle"
                                size={16}
                                color="#EA655B"
                              />
                              Add a new Sheet Packaging
                            </Button>
                          </div>
                        </GlobalSet>
                        </Col>
                      </Row>
                    )}
                    </Col>
                  </Row>
                </Form>
                </div>
                </HaberForm>
            </DetailFields>

            {(visibleToaster && !actionToaster.error) && (
            <AlertContainer
              color="green toaster"
              icon={alertGreen}
              msg={actionToaster.msg}
            />
            )}
            {(visibleToaster && actionToaster.error) && (
              <AlertContainer
                color="red toaster"
                icon={alertRed}
                msg={actionToaster.msg}
              />
            )}
            {newReelSideDrawer && (<AddReelPackaging
                visible={newReelSideDrawer}
                onClose={onClosePackagingDrawer}
                toasterAction={setActionToaster}
                showToaster={() => showToaster(setVisibleToaster)}
                type={packagingType}
                actionType={actionType}
                data={dataToPass}
            ></AddReelPackaging>)}
        </RightLayoutContainer>
    ) 
    
    // : (
    //   <></>
    // );
};
export default PackagingConfig;